<div class="chip-wrap" (click)="openModal(getTemplateByIndex(indexOfDeal, content, content2, content3))">
  <app-button [btnType]="'button'" [btnText]="type.charAt(0).toUpperCase() + type.slice(1)" [btnTitle]="type"
              [btnCss]="cssClass"></app-button>
</div>
<div (click)="openModal(getTemplateByIndex(indexOfDeal, content, content2, content3))">
  <h5 class="deal-text">{{dealText}}</h5>
  <p class="deal-info">{{dealInfo}}</p>
  <div class="time-wrap">
    <div class="svg-wrap">
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 0C2.6916 0 0 2.6916 0 6C0 9.3084 2.6916 12 6 12C9.3084 12 12 9.3084 12 6C12 2.6916 9.3084 0 6 0ZM9.45 6.6H5.4V2.4H6.6V5.4H9.45V6.6Z"
              fill="currentcolor" />
      </svg>
    </div>
    {{date}} - {{dateTo}}
  </div>
</div>

<!-- Design 1 -->
<ng-template class="custom-modal custom-coupon-modal" #content let-modal>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span></span>
    <span></span>
  </button>
  <div class="modal-body">
    <section class="coupon-card-section">
      <span class="color-bar"></span>
      <div class="coupon-card">
        <div class="coupon-left-card">
          <img [src]="dealData?.image || './assets/images/coupon1-img.png'" [alt]="dealData?.name" class="img-fluid img-coupon-full" />
        </div>
        <hr class="dashed-line d-md-none d-lg-none d-xl-none"/>
        <div class="coupon-right-card">
          <div class="coupon-text-dv">
            <h2>{{dealData?.name}}</h2>
            <div *ngIf="date != null && date != '' && dateTo != null" class="mb-2">{{date | date:'MMM d, y'}} - {{dateTo | date:'MMM d, y'}}</div>
            <div *ngIf="time != null && time != ''" class="mb-2">{{time}}</div>
            <div class="badge-coupon-dv">
              <span *ngIf="dealData?.conditions != null && dealData?.conditions != ''" class="badge-coupon badge-red"><b>{{dealData?.conditions}}</b></span>
              <span *ngIf="dealData?.output != null && dealData?.output != ''" class="badge-coupon badge-blue">
                {{dealData?.output}}
                <svg class="points-svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                </svg>
              </span>
            </div>
            <div class="desc-dv">
              <p>{{dealData?.description}}</p>
            </div>
          </div>
          <div class="btn-right-dv">
            <button class="btn btn-link-goto" (click)="navigateToRestaurant()">Go to Restaurant</button>
          </div>
        </div>
      </div>
    </section>
  </div>
</ng-template>

<!-- Design 2 -->
<ng-template class="custom-modal custom-coupon-modal" #content2 let-modal>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span></span>
    <span></span>
  </button>
  <div class="modal-body">
    <section class="coupon-card-section coupon-card-section2">
      <span class="color-bar"></span>
      <div class="coupon-card">
        <div class="coupon-left-card">
          <img [src]="dealData?.image || './assets/images/coupon2-img.png'" [alt]="dealData?.name" class="img-fluid img-coupon-full" />
        </div>
        <hr class="dashed-line d-md-none d-lg-none d-xl-none" />
        <div class="coupon-right-card">
          <div class="coupon-text-dv">
            <h2>{{dealData?.name}}</h2>
            <div *ngIf="date != null && date != '' && dateTo != null" class="mb-2">{{date | date:'MMM d, y'}} - {{dateTo | date:'MMM d, y'}}</div>
            <div *ngIf="time != null && time != ''" class="mb-2">{{time}}</div>
            <div class="badge-coupon-dv">
              <span *ngIf="dealData?.conditions != null && dealData?.conditions != ''" class="badge-coupon badge-red"><b>{{dealData?.conditions}}</b></span>
              <span *ngIf="dealData?.output != null && dealData?.output != ''" class="badge-coupon badge-blue">
                {{dealData?.output}}
                <svg class="points-svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                </svg>
              </span>
            </div>
            <div class="desc-dv">
              <p>{{dealData?.description}}</p>
            </div>
          </div>
          <div class="btn-right-dv">
            <button class="btn btn-link-goto" (click)="navigateToRestaurant()">Go to Restaurant</button>
          </div>
        </div>
      </div>
    </section>
  </div>
</ng-template>

<!-- Design 3 -->
<ng-template class="custom-modal custom-coupon-modal" #content3 let-modal>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span></span>
    <span></span>
  </button>
  <div class="modal-body">
    <section class="coupon-card-section coupon-card-section3">
      <span class="color-bar"></span>
      <div class="coupon-card">
        <div class="coupon-left-card">
          <img [src]="dealData?.image || './assets/images/coupon3-img.png'" [alt]="dealData?.name" class="img-fluid img-coupon-full" />
        </div>
        <hr class="dashed-line d-md-none d-lg-none d-xl-none" />
        <div class="coupon-right-card">
          <div class="coupon-text-dv">
            <h2>{{dealData?.name}}</h2>
            <div *ngIf="date != null && date != '' && dateTo != null" class="mb-2">{{date | date:'MMM d, y'}} - {{dateTo | date:'MMM d, y'}}</div>
            <div *ngIf="time != null && time != ''" class="mb-2">{{time}}</div>
            <div class="badge-coupon-dv">
              <span *ngIf="dealData?.conditions != null && dealData?.conditions != ''" class="badge-coupon badge-red"><b>{{dealData?.conditions}}</b></span>
              <span *ngIf="dealData?.output != null && dealData?.output != ''" class="badge-coupon badge-blue">
                {{dealData?.output}}
                <svg class="points-svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                </svg>
              </span>
            </div>
            <div class="desc-dv">
              <p>{{dealData?.description}}</p>
            </div>
          </div>
          <div class="btn-right-dv">
            <button class="btn btn-link-goto" (click)="navigateToRestaurant()">Go to Restaurant</button>
          </div>
        </div>
      </div>
    </section>
  </div>
</ng-template>
